module.exports = __webpack_public_path__ + "static/media/au.37a54427.svg";